const camadas = [
    {
        codigo: 'BR_LOCALIDADE_NIVEL_1',
        nome: 'Estados',
        label: 'Estados',
        layerName: 'vega-api-homolog:br_localidade_nivel_1',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'BR_LOCALIDADE_NIVEL_2',
        nome: 'Municípios',
        label: 'Municípios',
        layerName: 'vega-api-homolog:br_localidade_nivel_2',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'IMOVEL_RURAL',
        nome: 'CAR',
        label: 'CAR',
        layerName: 'vega-api:propriedade_rural',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#fff002',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'CARS_DECLARADOS',
        nome: 'Áreas declaradas do CAR',
        label: 'Áreas declaradas do CAR',
        layerName: 'vega-api:cars_declarados',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#8be365',
        opacidade: 100,
        inspecionar: false,
        subtitle: [
            {
                name: 'APP Total',
                colorIcon: '#e4ff15',
                opacidade: 100
            },
            {
                name: 'Área Consolidada',
                colorIcon: '#616161',
                opacidade: 100
            },
            {
                name: 'Área Não Classificada',
                colorIcon: '#ebf0dc',
                opacidade: 100
            },
            {
                name: 'Hidrografia',
                colorIcon: '#377eb8',
                opacidade: 100
            },
            {
                name: "Nascente ou olho d'água perene",
                colorIcon: '#0000ff',
                opacidade: 100
            },
            {
                name: 'Vegetação Nativa',
                colorIcon: '#33a02c',
                opacidade: 100
            },
            {
                name: 'Reserva Legal',
                colorIcon: '#4d654a',
                opacidade: 100
            }
        ]
    },
    {
        codigo: 'CARS_CLASSIFICADOS',
        nome: 'Áreas classificadas do CAR',
        label: 'Áreas classificadas do CAR',
        layerName: 'vega-api:cars_classificados',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#8be365',
        opacidade: 100,
        inspecionar: false,
        subtitle: [
            {
                name: 'APP',
                colorIcon: '#e4ff15',
                opacidade: 100
            },
            {
                name: 'APP a Recompor',
                colorIcon: '#d2ac16',
                opacidade: 100
            },
            {
                name: 'Área antropizada',
                colorIcon: '#8a8f8e',
                opacidade: 100
            },
            {
                name: 'Área consolidada',
                colorIcon: '#616161',
                opacidade: 100
            },
            {
                name: 'Hidrografia',
                colorIcon: '#377eb8',
                opacidade: 100
            },
            {
                name: 'Nascente',
                colorIcon: '#0000ff',
                opacidade: 100
            },
            {
                name: 'Vegetação nativa em APP',
                colorIcon: '#33a02c',
                opacidade: 100
            },
            {
                name: 'Vegetação nativa em RL',
                colorIcon: '#33a02c',
                opacidade: 100
            }
        ]
    },
    {
        codigo: 'PRODES',
        nome: 'PRODES Amazônia Legal',
        label: 'PRODES Amazônia Legal',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_PANTANAL',
        nome: 'PRODES Pantanal',
        label: 'PRODES Pantanal',
        layerName: 'vega-api:prodes_pantanal',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_MATA_ATLANTICA',
        nome: 'PRODES Mata Atlântica',
        label: 'PRODES Mata Atlântica',
        layerName: 'vega-api:prodes_mata_atlantica',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_PAMPA',
        nome: 'PRODES Pampa',
        label: 'PRODES Pampa',
        layerName: 'vega-api:prodes_pampa',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_CAATINGA',
        nome: 'PRODES Caatinga',
        label: 'PRODES Caatinga',
        layerName: 'vega-api:prodes_caatinga',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'TERRA_INDIGENA',
        nome: 'Terras Indígenas',
        label: 'Terras Indígenas',
        layerName: 'vega-api:terra_indigena',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#e69138',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PY_LOCALIDADE_NIVEL_1',
        nome: 'Departamentos Paraguai',
        label: 'Departamentos Paraguai',
        layerName: 'vega-api-homolog:py_localidade_nivel_1',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PY_LOCALIDADE_NIVEL_2',
        nome: 'Distritos Paraguai',
        label: 'Distritos Paraguai',
        layerName: 'vega-api-homolog:py_localidade_nivel_2',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AR_LOCALIDADE_NIVEL_1',
        nome: 'Provincias Argentina',
        label: 'Provincias Argentina',
        layerName: 'vega-api-homolog:ar_localidade_nivel_1',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AR_LOCALIDADE_NIVEL_2',
        nome: 'Departamentos Argentina',
        label: 'Departamentos Argentina',
        layerName: 'vega-api-homolog:ar_localidade_nivel_2',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'TERRA_INDIGENA_PARAGUAI',
        nome: 'Terras Indígenas Paraguai',
        label: 'Terras Indígenas Paraguai',
        layerName: 'vega-api:terra_indigena_paraguai',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#e69138',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'UNIDADE_CONSERVACAO_US',
        nome: 'Unidades de conservação de uso sustentável',
        label: 'Unidades de conservação de uso sustentável',
        layerName: 'vega-api:unidade_conservacao_uso_sustentavel',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#f6630b',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'UNIDADE_CONSERVACAO_PI',
        nome: 'Unidades de conservação de proteção integral',
        label: 'Unidades de conservação de proteção integral',
        layerName: 'vega-api:unidade_conservacao_protecao_integral',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA',
        nome: 'Áreas Embargadas (IBAMA)',
        label: 'Áreas Embargadas (IBAMA)',
        layerName: 'vega-api:area_embargada',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_SEDAM_RO',
        nome: 'Áreas Embargadas (SEDAM-RO)',
        label: 'Áreas Embargadas (SEDAM-RO)',
        layerName: 'vega-api:area_embargada_sedam_ro',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#ff0000',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_SEMA_MT',
        nome: 'Áreas Embargadas (SEMA-MT)',
        label: 'Áreas Embargadas (SEMA-MT)',
        layerName: 'vega-api:area_embargada_semas_mt',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#d100c5',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_ICMBIO',
        nome: 'Área embargada ICMBio',
        label: 'Área embargada ICMBio',
        layerName: 'vega-api:area_embargada_icmbio',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#c0fd79',
        opacidade: 100,
        inspecionar: true
    },

    {
        codigo: 'DESMATAMENTO_MAPBIOMAS',
        nome: 'Desmatamento MapBiomas',
        label: 'Desmatamento MapBiomas',
        layerName: 'vega-api:desmatamento_mapbiomas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#ff0000',
        opacidade: 100,
        inspecionar: true
    },

    {
        codigo: 'SISTEMA_ALERTAS_DESMATAMENTO_BIOMA_AMAZONIA',
        nome: 'Sistema de alertas de desmatamento bioma Amazônia - SAD',
        label: 'Sistema de alertas de desmatamento bioma Amazônia - SAD',
        layerName: 'vega-api:desmatamento_mapbiomas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#ff0000',
        opacidade: 100,
        inspecionar: true,
        CQL_FILTER: "fonte='{SAD}'"
    },

    {
        codigo: 'PRODES_CERRADO',
        nome: 'PRODES Cerrado',
        label: 'PRODES Cerrado',
        layerName: 'vega-api:prodes_cerrado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'DETER_AMAZONIA',
        nome: 'DETER Amazônia',
        label: 'DETER Amazônia',
        layerName: 'vega-api:deter_amazonia',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'DETER_CERRADO',
        nome: 'DETER Cerrado',
        label: 'DETER Cerrado',
        layerName: 'vega-api:deter_cerrado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'LDI',
        nome: 'LDI',
        label: 'LDI',
        layerName: 'vega-api:ldi',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'FLORESTAS_PUBLICAS',
        nome: 'Florestas Públicas',
        label: 'Florestas Públicas',
        layerName: 'vega-api:florestas_publicas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#c0fd79',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'MORATORIA_SOJA_PONTOS',
        nome: 'Moratória Soja - pontos',
        label: 'Moratória Soja - pontos',
        layerName: 'vega-api:moratoria_soja_pontos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#fff2cc',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PLANTIO_SOJA_23_MATOPIBA',
        nome: 'Plantio de Soja Safra 22/23 – MATOPIBA',
        label: 'Plantio de Soja Safra 22/23 – MATOPIBA',
        layerName: 'vega-api-homolog:matopiba',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        colorIcon: '#6aa84f',
        opacidade: 100,
        inspecionar: true
    },
    // {
    //     codigo: 'TERRITORIOS',
    //     nome: 'Territórios',
    //     label: 'Territórios',
    //     layerName: process.env.VUE_APP_LAYER_TERRITORIO + ':territorio',
    //     ativo: false,
    //     local: true,
    //     path: process.env.VUE_APP_LAYER_TERRITORIO + '/wms',
    //     colorIcon: '#0bfb00',
    //     opacidade: 100
    // },
    {
        codigo: 'BIOMAS',
        nome: 'Biomas',
        label: 'Biomas',
        layerName: 'vega-api:biomas',
        styleName: 'vega-api:biomas-classificados',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#8be365',
        opacidade: 100,
        inspecionar: true,
        subtitle: [
            {
                name: 'Amazonia',
                colorIcon: '#42a72a',
                opacidade: 100
            },
            {
                name: 'Cerrado',
                colorIcon: '#fde8a0',
                opacidade: 100
            },
            {
                name: 'Caatinga',
                colorIcon: '#f69f8c',
                opacidade: 100
            },
            {
                name: 'Pantanal',
                colorIcon: '#a3a189',
                opacidade: 100
            },
            {
                name: 'Mata Atlântica',
                colorIcon: '#fbe1fe',
                opacidade: 100
            },
            {
                name: 'Pampa',
                colorIcon: '#d3ecb5',
                opacidade: 100
            }
        ]
    },
    {
        codigo: 'COBERTURA_SOLO_MAPBIOMAS',
        nome: 'Cobertura do Solo - Mapbiomas',
        label: 'Cobertura do Solo - Mapbiomas',
        layerName: 'vega-api:cobertura_solo_map_biomas_2021',
        styleName: 'vega-api:cobertura_solo_mapbiomas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#8be365',
        opacidade: 100,
        inspecionar: true,
        subtitle: [
            {
                name: 'Afloramento Rochoso',
                colorIcon: '#FF8C00',
                opacidade: 100
            },
            {
                name: 'Agricultura',
                colorIcon: '#E974ED',
                opacidade: 100
            },
            {
                name: 'Algodão beta',
                colorIcon: '#660066',
                opacidade: 100
            },
            {
                name: 'Apicum',
                colorIcon: '#968C46',
                opacidade: 100
            },
            {
                name: 'Aquicultura',
                colorIcon: '#29EEE4',
                opacidade: 100
            },
            {
                name: 'Área Urbanizada',
                colorIcon: '#AF2A2A',
                opacidade: 100
            },
            {
                name: 'Arroz',
                colorIcon: '#982C9E',
                opacidade: 100
            },
            {
                name: 'Café',
                colorIcon: '#CCA0D4',
                opacidade: 100
            },
            {
                name: 'Citrus',
                colorIcon: '#D082DE',
                opacidade: 100
            },
            {
                name: 'Campo Alagado e Área Pantanosa',
                colorIcon: '#45C2A5',
                opacidade: 100
            },
            {
                name: 'Cana',
                colorIcon: '#C27BA0',
                opacidade: 100
            },
            {
                name: 'Formação Campestre',
                colorIcon: '#B8AF4F',
                opacidade: 100
            },
            {
                name: 'Formação Florestal',
                colorIcon: '#006400',
                opacidade: 100
            },
            {
                name: 'Formação Savânica',
                colorIcon: '#32CD32',
                opacidade: 100
            },
            {
                name: 'Lavoura Perene',
                colorIcon: '#F3B4F1',
                opacidade: 100
            },
            {
                name: 'Lavoura Temporária',
                colorIcon: '#D5A6BD',
                opacidade: 100
            },
            {
                name: 'Mangue',
                colorIcon: '#687537',
                opacidade: 100
            },
            {
                name: 'Mineração',
                colorIcon: '#8A2BE2',
                opacidade: 100
            },
            {
                name: 'Mosaico de Usos',
                colorIcon: '#FFEFC3',
                opacidade: 100
            },
            {
                name: 'Outras Áreas não Vegetadas',
                colorIcon: '#FF99FF',
                opacidade: 100
            },
            {
                name: 'Outras Formações não Florestais',
                colorIcon: '#BDB76B',
                opacidade: 100
            },
            {
                name: 'Outras Lavouras Perenes',
                colorIcon: '#CD49E4',
                opacidade: 100
            },
            {
                name: 'Outras Lavouras Temporárias',
                colorIcon: '#E787F8',
                opacidade: 100
            },
            {
                name: 'Pastagem',
                colorIcon: '#FFD966',
                opacidade: 100
            },
            {
                name: 'Praia Duna e Areal',
                colorIcon: '#DD7E6B',
                opacidade: 100
            },
            {
                name: 'Restinga Arborizada',
                colorIcon: '#6B9932',
                opacidade: 100
            },
            {
                name: 'Restinga Herbácea',
                colorIcon: '#66FFCC',
                opacidade: 100
            },
            {
                name: 'Rio Lago e Oceano',
                colorIcon: '#0000FF',
                opacidade: 100
            },
            {
                name: 'Silvicultura monocultura',
                colorIcon: '#935132',
                opacidade: 100
            },
            {
                name: 'Soja',
                colorIcon: '#C59FF4',
                opacidade: 100
            }
        ]
    },
    {
        codigo: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS',
        nome: 'Área de soja - coleção 7 - Mapbiomas',
        label: 'Área de soja - coleção 7 - Mapbiomas',
        layerName: 'vega-api:cobertura_solo_map_biomas_2021',
        styleName: 'soja_mapbiomas_2021',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#C59FF4',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'INCRA_SIGEF_PRIVADO',
        nome: 'INCRA/SIGEF(Privado)',
        label: 'INCRA/SIGEF(Privado)',
        layerName: 'vega-api:sigef_privado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#b45f05',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'INCRA_SIGEF_PUBLICO',
        nome: 'INCRA/sigef (Público)',
        label: 'INCRA/sigef (Público)',
        layerName: 'vega-api:sigef_publico',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#9e7f05',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'INCRA_ASSENTAMENTOS',
        nome: 'Assentamento Rural',
        label: 'Assentamento Rural',
        layerName: 'vega-api:assentamentos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#e5be8f',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'INCRA_QUILOMBOLAS',
        nome: 'Comunidades quilombolas',
        label: 'Comunidades quilombolas',
        layerName: 'vega-api:quilombolas_incra',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#c1b0ab',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'FAIXA_FRONTEIRA',
        nome: 'Faixa de fronteira',
        label: 'Faixa de fronteira',
        layerName: 'vega-api:faixa_fronteira',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#E06666',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'POC_AREA_PLANTADA_GAMELEIRA',
        nome: 'Área plantada Gameleira',
        label: 'Área plantada Gameleira',
        layerName: 'pocs:car_plantio_gameleira',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
        colorIcon: '#6AA84F',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_GOIAS',
        nome: 'Áreas Embargadas - GO',
        label: 'Áreas Embargadas - GO',
        layerName: 'vega-api:area_embargada_goias',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#99357B',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_PIAUI',
        nome: 'Áreas Embargadas Piauí',
        label: 'Áreas Embargadas Piauí',
        layerName: 'vega-api:area_embargada_piaui',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PLANTIO_SOJA',
        nome: 'Plantio de soja',
        label: 'Plantio de soja',
        layerName: 'pocs:areas_plantio_soja_2020',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
        colorIcon: '#6aa84f',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'QUEIMADAS',
        nome: 'Queimadas',
        label: 'Queimadas',
        layerName: 'vega-api:queimadas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#ff0000',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'MORATORIA_SOJA',
        nome: 'Moratória Soja - polígonos',
        label: 'Moratória Soja - polígonos',
        layerName: 'vega-api:moratoria_soja_poligonos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#e19418',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'SITIOS_ARQUEOLOGICOS',
        nome: 'Sítios Arqueológicos',
        label: 'Sítios Arqueológicos',
        layerName: 'vega-api:sitios_arqueologicos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b9770e',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
        nome: 'Áreas Silvestres Protegidas do Paraguai',
        label: 'Áreas Silvestres Protegidas do Paraguai',
        layerName: 'vega-api:areas_protegidas_paraguai',
        ativo: true,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    }
];

export default camadas;
